import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { RocketIcon, MapPinIcon, PhoneIcon, MailIcon, GlobeIcon } from 'lucide-react';
export function FinalCTA() {
  return <SlideLayout centered data-id="element-181">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(128,80,235,0.08)_0%,transparent_50%)] pointer-events-none" data-id="element-182" />
      <div className="relative z-10 flex flex-col items-center max-w-4xl mx-auto text-center px-2" data-id="element-183">
        <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-gold-500/15 flex items-center justify-center mb-4 sm:mb-8 border border-gold-500/30 shadow-[0_0_40px_rgba(128,80,235,0.15)]" data-id="element-184">
          <RocketIcon className="w-7 h-7 sm:w-10 sm:h-10 text-gold-600" data-id="element-185" />
        </div>

        <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-3 sm:mb-6 tracking-tight leading-tight" data-id="element-186">
          Let's Turn Your Website Into a{' '}
          <span className="text-gold-600" data-id="element-187">Lead Generation Engine</span>
        </h2>

        <p className="text-sm sm:text-xl md:text-2xl text-slate-600 font-light mb-6 sm:mb-12" data-id="element-188">
          The opportunity is clear. The strategy is ready. Let's get started.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 w-full mb-8 sm:mb-16 text-left" data-id="element-189">
          <div className="glass-card p-4 sm:p-6 border-t-4 border-t-gold-500" data-id="element-190">
            <div className="text-gold-600 font-bold text-sm sm:text-base mb-1 sm:mb-2" data-id="element-191">
              Step 1
            </div>
            <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-192">
              Strategy Alignment
            </h3>
            <p className="text-xs sm:text-sm text-slate-500" data-id="element-193">
              Align on goals, priorities, and timeline.
            </p>
          </div>
          <div className="glass-card p-4 sm:p-6 border-t-4 border-t-gold-500" data-id="element-194">
            <div className="text-gold-600 font-bold text-sm sm:text-base mb-1 sm:mb-2" data-id="element-195">
              Step 2
            </div>
            <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-196">
              Implementation Planning
            </h3>
            <p className="text-xs sm:text-sm text-slate-500" data-id="element-197">
              Finalize scope, deliverables, and launch plan.
            </p>
          </div>
          <div className="glass-card p-4 sm:p-6 border-t-4 border-t-gold-500" data-id="element-198">
            <div className="text-gold-600 font-bold text-sm sm:text-base mb-1 sm:mb-2" data-id="element-199">
              Step 3
            </div>
            <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-200">
              Campaign Kickoff
            </h3>
            <p className="text-xs sm:text-sm text-slate-500" data-id="element-201">
              Begin executing your SEO growth strategy.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 w-full max-w-3xl" data-id="element-202">
          <div className="glass-card p-3 sm:p-5 flex flex-col items-center text-center gap-1 sm:gap-2" data-id="element-203">
            <MapPinIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-204" />
            <span className="text-[9px] sm:text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-205">
              Address
            </span>
            <span className="text-[11px] sm:text-sm text-slate-700 leading-snug" data-id="element-206">
              590 Alden Rd #210 Markham, Ontario
            </span>
          </div>
          <div className="glass-card p-3 sm:p-5 flex flex-col items-center text-center gap-1 sm:gap-2" data-id="element-207">
            <PhoneIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-208" />
            <span className="text-[9px] sm:text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-209">
              Phone
            </span>
            <span className="text-[11px] sm:text-sm text-slate-700" data-id="element-210">
              (905) 604-7900
            </span>
          </div>
          <div className="glass-card p-3 sm:p-5 flex flex-col items-center text-center gap-1 sm:gap-2" data-id="element-211">
            <MailIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-212" />
            <span className="text-[9px] sm:text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-213">
              Email
            </span>
            <span className="text-[11px] sm:text-sm text-slate-700" data-id="element-214">
              info@digilite.ca
            </span>
          </div>
          <div className="glass-card p-3 sm:p-5 flex flex-col items-center text-center gap-1 sm:gap-2" data-id="element-215">
            <GlobeIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-216" />
            <span className="text-[9px] sm:text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-217">
              Website
            </span>
            <span className="text-[11px] sm:text-sm text-slate-700" data-id="element-218">
              digilite.ca
            </span>
          </div>
        </div>
      </div>
    </SlideLayout>;
}